<script lang="ts">
	import Router, { replace } from 'svelte-spa-router';
	import { routes } from './routes';
	import { isAuthenticated, signout } from './shared/stores';

	// Handles the "conditionsFailed" event dispatched by the router when a component can't be loaded because one of its pre-condition failed
	async function conditionsFailed(event) {
		if ((await isAuthenticated()) == false) {
			await signout();
		}
	}
</script>

<Router routes="{routes}" on:conditionsFailed="{conditionsFailed}" />
